// --- React
import React from 'react';
// --- UI Components
import { Col, Row } from 'antd';
import Typography from '@dtci/spellbook/Typography';
// --- Utils
import { getSummaryDetails } from '../utils/getDetailsData';
// --- Styles
import '../../styles.scss';

/**
 * SummaryCard Component
 *
 * This component is responsible for rendering a card that displays detailed
 * information about a product's summary data.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.details - The details of the product to be displayed.
 * @returns {JSX.Element} Summary card with detailed information.
 */
export function SummaryCard({ details }) {
    // Function to extract summary details from the provided data
    const summaryDetails = getSummaryDetails(details);

    return (
        <Row style={{ marginTop: 20 }}>
            <Col>
                {summaryDetails.map(({ label, value }, index) => (
                    <Row key={index}>
                        <Typography variant="T20">
                            <b>{label}:</b>
                            <br />
                            {value}
                        </Typography>
                    </Row>
                ))}
            </Col>
        </Row>
    );
}
